import { render, staticRenderFns } from "./BaseDataTableFilters.vue?vue&type=template&id=3788f63d&scoped=true"
import script from "./BaseDataTableFilters.vue?vue&type=script&lang=js"
export * from "./BaseDataTableFilters.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTableFilters.vue?vue&type=style&index=0&id=3788f63d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3788f63d",
  null
  
)

export default component.exports